import axios from "axios";

const api = axios.create({
  baseURL: "https://bancher.toxiplus.com/api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    // Envía el hostname actual para que el backend identifique el tenant
    // En producción: "bancher.toxiplus.com" → slug "bancher"
    // En local: "localhost" → no matchea ningún tenant, usa fallback
    "X-Tenant": window.location.hostname,
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// A 401 means the token is missing, expired, or its user was deactivated
// mid-session — without this, every page's own catch(err) => console.error
// swallows it and the user is left staring at a stale/empty screen forever.
// This app has no router: App.js renders <Login/> purely from `user` being
// null, so clearing storage and reloading is enough to drop back to it.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.endsWith("/login")) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default api;
